// extracted by mini-css-extract-plugin
export default {"white":"#fff","lightgreen":"#1ee5a0","maincolor":"#003c71","lightgrey":"#89a3c3","background":"#d9e3ec","greybox":"#e8eef3","helpWrapper":"SearchHelp_helpWrapper__ACj6l"};